import AdsClickRoundedIcon from "@mui/icons-material/AdsClickRounded";
import CloseFullscreenRoundedIcon from "@mui/icons-material/CloseFullscreenRounded";
import OpenInFullRoundedIcon from "@mui/icons-material/OpenInFullRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { Box, Button, FormControlLabel, IconButton, Stack, Switch, Tooltip } from "@mui/material";
import type { PropsWithChildren, ReactNode } from "react";
import ArtifactHint from "./ArtifactHint";

const DRILL_DOWN_HINT = "Click a number to see the report and ledger entries behind it";

interface Props {
  isDrillMode: boolean;
  isFullScreen: boolean;
  dataSources?: ReactNode;
  onDrillModeChange: (enabled: boolean) => void;
  onFullScreenChange: (fullScreen: boolean) => void;
  onRefresh: () => void;
}

const ArtifactToolbar = ({
  isDrillMode,
  isFullScreen,
  dataSources,
  onDrillModeChange,
  onFullScreenChange,
  onRefresh,
  children,
}: PropsWithChildren<Props>) => {
  const fullScreenLabel = isFullScreen ? "Exit full screen" : "Open in full screen";
  return (
    <>
      <Stack direction="row" spacing={1} sx={{ alignItems: "flex-start", pl: 2, pr: 1.5, pt: 1.5, pb: 0.5 }}>
        <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
        <Stack direction="row" spacing={1} sx={{ alignItems: "center", flexShrink: 0 }}>
          <Tooltip title={DRILL_DOWN_HINT}>
            <FormControlLabel
              control={<Switch checked={isDrillMode} onChange={(_, checked) => onDrillModeChange(checked)} />}
              label="Drill-down"
            />
          </Tooltip>
          <Button color="secondary" startIcon={<RefreshRoundedIcon />} onClick={onRefresh}>
            Refresh
          </Button>
          <Tooltip title={fullScreenLabel}>
            <IconButton aria-label={fullScreenLabel} onClick={() => onFullScreenChange(!isFullScreen)}>
              {isFullScreen ? <CloseFullscreenRoundedIcon /> : <OpenInFullRoundedIcon />}
            </IconButton>
          </Tooltip>
        </Stack>
      </Stack>
      {isDrillMode && (
        <Box sx={{ mx: 2, mt: 0.75 }}>
          <ArtifactHint
            icon={<AdsClickRoundedIcon color="secondary" />}
            text={`${DRILL_DOWN_HINT}.`}
            action={dataSources}
          />
        </Box>
      )}
    </>
  );
};

export default ArtifactToolbar;
